import { cx, css } from '@linaria/core';
import { styled } from '@linaria/react';
import { flex, theming, breakpoints } from 'styles/utils';
import { base } from 'styles/variables';

// const EXPANDED_SIDEBAR_WIDTH = '17.5rem';

export const SIDEBAR_SECTIONS_GAP = '1.5rem';
export const appContainer = "odules__Sidebar__Sidebar_styles_ts-appContainer-asa6cro";
export const CircularButton = /*#__PURE__*/styled("button")({
  name: "CircularButton",
  class: "odules__Sidebar__Sidebar_styles_ts-CircularButton-c27n4g2"
});
export const appInfoArea = cx("odules__Sidebar__Sidebar_styles_ts-appInfoArea-amaz8vj", flex.init, flex.alignItems.center);
export const listWithGap = cx("odules__Sidebar__Sidebar_styles_ts-listWithGap-ljeirct", flex.init, flex.direction.column);
export const sidebarWrapper = cx("odules__Sidebar__Sidebar_styles_ts-sidebarWrapper-so9vy5c", listWithGap);
export const mobileSidebar = cx("odules__Sidebar__Sidebar_styles_ts-mobileSidebar-mogebx2", flex.init, flex.alignItems.center);
export const mobilePopoverStyles = "odules__Sidebar__Sidebar_styles_ts-mobilePopoverStyles-m2pql3t";
export const sidebarScrollableContainer = "odules__Sidebar__Sidebar_styles_ts-sidebarScrollableContainer-sjvjtj8";
export const motionMenuIcon = "odules__Sidebar__Sidebar_styles_ts-motionMenuIcon-m1p0p1ta";
export const menu = "odules__Sidebar__Sidebar_styles_ts-menu-mi6sxnu";
export const mobileMenu = "odules__Sidebar__Sidebar_styles_ts-mobileMenu-m12jwtr2";
export const submenuIcon = "odules__Sidebar__Sidebar_styles_ts-submenuIcon-s1a8xmdc";
export const shrinkText = "odules__Sidebar__Sidebar_styles_ts-shrinkText-sexlod4";
export const appNameArea = "odules__Sidebar__Sidebar_styles_ts-appNameArea-a18l8aq3";
export const userArea = "odules__Sidebar__Sidebar_styles_ts-userArea-u1jnsjwf";
export const intersectionDetecterDiv = "odules__Sidebar__Sidebar_styles_ts-intersectionDetecterDiv-i1l3vyqx";
export const isNotCollapsedSticky = "odules__Sidebar__Sidebar_styles_ts-isNotCollapsedSticky-icrczd6";
export const isCollapsedSticky = "odules__Sidebar__Sidebar_styles_ts-isCollapsedSticky-ir0024v";
export const isNotSticky = "odules__Sidebar__Sidebar_styles_ts-isNotSticky-i10vgt1e";

require("./Sidebar.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Sidebar.styles.ts");